import { ReactNode, useRef } from 'react';
import Button from '@mui/material/Button';
import { useAppForm } from '~/components/Form';

type UploadFormProps = {
  onSubmit: (values: FormValues) => void;
  label: ReactNode;
};

type FormValues = {
  file: FileList;
};

export const UploadForm = (props: UploadFormProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const form = useAppForm({
    defaultValues: {
      file: null as FileList | null,
    },
    onSubmit: ({ value }) => {
      if (value.file) {
        props.onSubmit({ file: value.file });
        form.reset();
      }
    },
  });
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}
    >
      <form.Field name="file">
        {(field) => (
          <input
            ref={inputRef}
            type="file"
            aria-label={
              typeof props.label === 'string' ? props.label : undefined
            }
            style={{ display: 'none' }}
            onChange={(e) => {
              if (e.target.files) {
                field.handleChange(e.target.files);
                form.handleSubmit();
              }
            }}
          />
        )}
      </form.Field>
      <Button variant="outlined" onClick={() => inputRef.current?.click()}>
        {props.label}
      </Button>
    </form>
  );
};
export default UploadForm;
